import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertIcon, Box, StyleProps } from '@bonusly/design-system';

export const NoAwardSelected: FC<StyleProps> = (props) => {
	const { t } = useTranslation('recognition');

	return (
		<Box {...props}>
			<Alert status="error">
				<AlertIcon color="red.700" />
				<AlertDescription color="red.700" fontSize="md">
					{t('awards.give_modal.error_no_award_selected')}
				</AlertDescription>
			</Alert>
		</Box>
	);
};
